import enquiryWhite from '@/assets/salesLead/main-tab-icon/Enquiry_white.svg';
import nameCardWhite from '@/assets/salesLead/main-tab-icon/id_card_small_white.svg';
import favoriteWhite from '@/assets/salesLead/main-tab-icon/favorite_white.svg';
import postMatchWhite from '@/assets/salesLead/main-tab-icon/Post_match_white.svg';

/** 主 Tab 选中态：白色 icon（紫色底上使用） */
export default {
    '0': enquiryWhite,
    '1': nameCardWhite,
    '2': favoriteWhite,
    '3': postMatchWhite,
};
